import request from '@/utils/request'
//更新患者协同备注
export function updatePatRemark(data) {
  return request({
    url: '/health-user/user/remark/bdRemarkPatient',
    method: 'post',
    data
  })
}
//查看患者协同备注
export function getPatientRemarkNotes(data) {
  return request({
    url: '/health-user/user/remark/getPatientTogetherRemark',
    method: 'get',
    params: data
  })
}
//查看医生协同备注
export function getDoctRemarkNotes(data) {
  return request({
    url: '/health-user/user/remark/getDoctorTogetherRemark',
    method: 'get',
    params: data
  })
}
// 更新医生协同备注
export function updateDoctRemark(data) {
  return request({
    url: '/health-user/user/remark/assRemarkDoctor',
    method: 'post',
    data
  })
}
